module.exports = __webpack_public_path__ + "static/media/idea-recommender.76c743cc.png";